"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PLAYING: 'PLAYING',
  PAUSED: 'PAUSED',
  MUTE: 'MUTE',
  VOLUME_DOWN: 'VOLUME_DOWN',
  VOLUME_UP: 'VOLUME_UP',
  PROGRESS_BACK: 'PROGRESS_BACK',
  PROGRESS_FORWARD: 'PROGRESS_FORWARD'
};
exports.default = _default;